import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../constants/constants';
import { SIDE_BAR_MODE } from './constants/constant';
export const componentKey = "MAIN_DASHBOARD";

const initialState = {
    isMenuActive: false,
    showProfileDrawer: false,
    showOtherAppsDrawer: false,
    sideBarMode: SIDE_BAR_MODE.HOVER, 
    minimizedSidebarIconSize: true,
    loadingState: { state: PAGE_STATE.PRE_LOADING, message: "" },
    onboardingPending: false,
    onBoardingScreenToStart: "",
    showChangePlan: false,
    showPrepayWalletDrawer: false,
    showPaymentNotAllowedPopup: false,
    IsTinUnmaskAllowed: false,
    showManageCardDrawer: false,
    errorInProfile: false,
    toggled: false,
};

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setMenuActive : (state, action) => {
            state.isMenuActive = action.payload;
        },
        setShowProfileDrawer : (state, action) => {
            state.showProfileDrawer = action.payload;
        },
        setShowOtherAppsDrawer : (state, action) => {
            state.showOtherAppsDrawer = action.payload;
        },
        setUserDetails: (state, action) => {
            state.userDetails = action.payload;
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setOnboardingPending: (state, action) => {
            state.onboardingPending = action.payload;
        },
        setOnBoardingScreenToStart: (state, action) => {
            state.onBoardingScreenToStart = action.payload;
        },
        setShowChangePlan: (state, action) => {
            state.showChangePlan = action.payload;
        },
        setShowPrepayWalletDrawer: (state, action) => {
            state.showPrepayWalletDrawer = action.payload;
        },
        resetDashboardState: (state, action) => {
            return {
                ...initialState,
            }
        },
        setShowPaymentNotAllowedPopup: (state, action) => {
            state.showPaymentNotAllowedPopup = action.payload;
        },
        setIsTinUnmaskAllowed: (state, action) =>{
            state.IsTinUnmaskAllowed = action.payload
        },
        setShowManageCardDrawer : (state, action) => {
            state.showManageCardDrawer = action.payload;
        },
        setErrorInProfile : (state, action) => {
            state.errorInProfile = action.payload;
        },
        setToggled : (state, action) => {
            state.toggled = action.payload;
        },

    },
    initialReducerState: initialState
});

export const { setShowChangePlan, setShowManageCardDrawer, setMenuActive, setShowPaymentNotAllowedPopup, setUserDetails, setLoadingState, setOnboardingPending, setOnBoardingScreenToStart, setShowProfileDrawer, setShowOtherAppsDrawer, setShowPrepayWalletDrawer, resetDashboardState, setIsTinUnmaskAllowed, setToggled, setErrorInProfile } = actions;
